import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Report, ReportTreeTypeRefresh } from '../../reports/models/report';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { getEmployeeViews, GetOptions } from '@onviobr/services/core/employee-views';
import { FilterOperations } from '@onviobr/services/utils/sorting-filtering';

@Injectable({
	providedIn: 'root'
})
export class ProfileReportsService {
	refreshStandardProfile = new BehaviorSubject<boolean>(false);
	refreshStaffProfile = new BehaviorSubject<boolean>(false);
	refreshFirmProfile = new BehaviorSubject<boolean>(false);
	getEmployeeViews = getEmployeeViews;
	employeeId: string;
	reports: Report[] = [];
	constructor(public http: HttpClient) {

	}

	refreshProfile(refreshProfile: ReportTreeTypeRefresh) {
		if (refreshProfile.isSatndardChange) {
			this.refreshStandardProfile.next(true);
		}
		if (refreshProfile.isStaffChange) {
			this.refreshStaffProfile.next(true);
		}
		if (refreshProfile.isFirmChange) {
			this.refreshFirmProfile.next(true);
		}
	}

	readReportProfile(companyId: string, profileId: string): Observable<any> {
		return this.http.get(`/api/core/v1/companies/${companyId}/report-profiles/${profileId}`);
	}

	reportDefinition(companyId: string, startIndex: number): Observable<any> {

		const params = new HttpParams()
			.set('filter', JSON.stringify({ items: [{ by: 'reportLayoutType.id', op: 'EQ', value: 'STANDARDREPORT' }] }))
			.set('orderBy', 'name asc')
			.set('searchBy', 'name,reportCategoryType.name')
			.set('startIndex', startIndex.toString());

		return this.http.get(`/api/core/v1/companies/${companyId}/report-definition-basics`, { params });
	}
	staffProfile(companyId: string, employeeId: string, startIndex: number): Observable<any> {
		const params = new HttpParams()
			.set('startIndex', startIndex.toString())
			.set('employeeId', employeeId);
		return this.http.get(`/api/core/v1/companies/${companyId}/report-profiles`, { params });
	}

	firmProfile(companyId: string, startIndex: number ): Observable<any> {
		const params = new HttpParams()
			.set('startIndex', startIndex.toString());
		return this.http.get(`/api/core/v1/companies/${companyId}/report-profiles`, { params });
	}

	profileType(): Observable<string[]> {
		return of(['Staff', 'Firm']);
	}

	saveProfile(profile: any): Observable<any> {
		return this.http.post(`/api/core/v1/companies/${profile.companyId}/report-profiles`, profile);
	}

	updateProfile(profile: any): Observable<any> {
		return this.http.put(`/api/core/v1/companies/${profile.companyId}/report-profiles`, profile);
	}

	async readEmployeeId(companyId: string, contactId: string): Promise<string> {
		if (this.employeeId) {
			return this.employeeId;
		} else {
			const param: GetOptions = {
				companyId,
				expand: 'contactView.id',
				filter: { items: [{ by: 'contactView.id', op: FilterOperations.EQ, value: contactId }] }
			};
			const employeeView = await this.getEmployeeViews(param);
			this.employeeId = employeeView.items[0].id;
			return this.employeeId;
		}

	}

	removeProfile(profile: string, companyId: string): Observable<any> {
		return this.http.delete(`/api/core/v1/companies/${companyId}/report-profiles/${profile}`);
	}

	readReportDateRange(): Observable<any> {
		const params = new HttpParams().set('forStandardReport', 'true');
		return this.http.get('/api/core/v1/report-date-ranges', { params });
	}

	verifyUniqueValueForProfile(companyId: any, value: any, profileId?: any, employeeId?: any): Observable<any> {
		let params = new HttpParams().set('value', value);

		if (profileId) {
			params =  params.set('reportProfileID', profileId);
		}

		if (employeeId) {
			params = params.set('employeeId', employeeId);
		}

		return this.http.get(`/api/core/v1/companies/${companyId}/report-profiles/verify-value-is-unique`, { params });
	}
}
